
















import {Component, Vue} from 'vue-property-decorator';
import LoginForm from '@/app/auth/login/LoginForm.vue';
import ILoginForm from '@/app/auth/login/ILoginForm';
import FormHeader from '@/app/common/component/FormHeader.vue';
import HeaderImg from '@/app/common/component/HeaderImg.vue';
import NotificationService from '@/app/common/service/NotificationService';
import AuthService from '@/app/common/service/AuthService';
import IUserInfo from '@/app/common/model/IUserInfo';
import StorageRepository from '@/app/common/repository/StorageRepository';

@Component({
  name: 'LoginContainer',
  components: {LoginForm, FormHeader, HeaderImg},
})
export default class LoginContainer extends Vue {
  get canRegister(): boolean {
    return this.$store.getters.canRegister;
  }
  get hasLicense(): boolean {
    return !!this.$store.getters.license;
  }

  get logoUrl(): string | null {
    return this.$store.getters.logoUrl;
  }

  public async onLogin(loginApi: ILoginForm): Promise<void> {
    try {
      await AuthService.login(loginApi);
    } catch (e) {
      NotificationService.error(e);
    }
  }
}
